import React, { useState, useEffect } from 'react';
import { templateApi } from '../../services/consts';
import {
   Alert,
   UncontrolledAlert,
   Card,
   CardBody,
   CardTitle,
   Button,
   Table
} from 'reactstrap';
import { tokenHeader, getUserToken } from "../../services/user-service";
import { getTemplates, dateFormat } from '../../services/template';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const apiEndPoint = templateApi;
const EmailTemplate = (props) => {
   // For Dismiss Button with Alert
   //  const [visible, setVisible] = useState(true);
   const [loaded, setLoaded] = useState(false);
   const [templates, setTemplates] = useState([]);

   var doDelete = (id) => {
      setLoaded(false);
      fetch(apiEndPoint + '/' + id, {
         method: 'delete',
         body: JSON.stringify({ id: id }),
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            [tokenHeader]: getUserToken()
         }
      }).then(function (result) {
         //  console.log("record deleted.")
         toast.success('Template deleted');
         getTemplateData();
      })
   }

   var doEdit = (id) => {
      props.history.push('/template/edit/' + id);
   }

   var getTemplateData = () => {
      getTemplates().then((templates) => {
         setTemplates(templates);
      });
   }

   useEffect(() => {
      if (!loaded) {
         getTemplateData();
         setLoaded(true);
      }
   });

   return (
      <div>
         <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
         />
         <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
               <i className="mdi mdi-email-open mr-2"> </i>
            Templates
          </CardTitle>
            <CardBody className="">
               <Button color="success" onClick={() => {
                  props.history.push('/template/add');
               }
               }><i className="mdi mdi-plus-box mdi-18px"></i> Add Template</Button> <br /><br />
               <Table style={{ tableLayout: 'fixed' }} striped bordered hover size="sm">
                  <thead>
                     <tr>
                        <th style={{ width: '3rem' }}></th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Name</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Slug</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Subject</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Type</th>
                        <th style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>Created At</th>
                        {/* <th>Edit</th> */}
                        <th style={{ width: '3rem' }}></th>
                     </tr>
                  </thead>
                  <tbody>
                     {templates.length > 0 ? templates.map(item => (
                        <tr key={item.id}>
                           <td style={{ textAlign: 'center', color: 'blue' }}>
                              <i className="mdi mdi-pencil-circle mdi-24px" onClick={() => { doEdit(item.id) }}></i>
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.name ? item.name : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.slug ? item.slug : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.subject ? item.subject : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.type ? item.type : '-'}
                           </td>
                           <td style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                              {item.createdAt ? dateFormat(item.createdAt) : '-'}
                           </td>
                           <td style={{ textAlign: 'center' }}><Button className="btn btn-sm" style={{ borderRadius: '50px' }} color="danger" onClick={() => { doDelete(item.id) }}><i className="mdi mdi-delete"></i></Button></td>
                        </tr>
                     )) : <tr><td colSpan={6} style={{ textAlign: 'center' }}><b>No Data Available</b></td></tr>}

                  </tbody>
               </Table>
            </CardBody>
         </Card>
      </div>
   );
}

export default EmailTemplate;
